export function packShelves(rects, pageW, pageH, padding) {
    // Tallest first keeps shelves tight; stable on key for determinism.
    const sorted = [...rects].sort((a, b) => b.h - a.h || b.w - a.w || (a.key < b.key ? -1 : a.key > b.key ? 1 : 0));
    const out = [];
    let page = 0;
    let x = padding;
    let y = padding;
    let shelfH = 0;
    for (const r of sorted) {
        if (r.w + padding * 2 > pageW || r.h + padding * 2 > pageH) {
            throw new Error(`packShelves: "${r.key}" (${r.w}x${r.h}) does not fit a ${pageW}x${pageH} page`);
        }
        if (x + r.w + padding > pageW) {
            // New shelf.
            x = padding;
            y += shelfH + padding;
            shelfH = 0;
        }
        if (y + r.h + padding > pageH) {
            // New page.
            page++;
            x = padding;
            y = padding;
            shelfH = 0;
        }
        out.push({ key: r.key, page, x, y, w: r.w, h: r.h });
        x += r.w + padding;
        if (r.h > shelfH)
            shelfH = r.h;
    }
    return out;
}
